import script from "./AddUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./AddUpdate.vue?vue&type=script&setup=true&lang=js"

export default script